import { render, staticRenderFns } from "./ArticleIndex.vue?vue&type=template&id=84c99fb6&scoped=true"
import script from "./ArticleIndex.vue?vue&type=script&lang=js"
export * from "./ArticleIndex.vue?vue&type=script&lang=js"
import style0 from "./ArticleIndex.vue?vue&type=style&index=0&id=84c99fb6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c99fb6",
  null
  
)

/* custom blocks */
import block0 from "./ArticleIndex.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports